export default "__VITE_ASSET__fa66e1dd__"